import axios from 'axios';

// This interceptor is used to check if the app needs to be reloaded
// for the axios instance and all instances created with axios.create
function attachInterceptors(instance) {
  instance.interceptors.response.use(
    (response) => {
      const headers = response.headers;
      const appVersion = headers['x-app-version'];
      const forceReload = headers['x-force-reload'];

      let isAppReloadRequired = false;
      const isLocalEnvironment = process.env.REACT_APP_ENVIRONMENT === 'local';
      if (appVersion && appVersion !== process.env.REACT_APP_VERSION && !isLocalEnvironment) {
        isAppReloadRequired = true;
      }
      else if (forceReload === 'true') {
        isAppReloadRequired = true;
      }
      else {
        isAppReloadRequired = false;
      }

      if (isAppReloadRequired) {
        // Emit a custom event that can be listened to by the App component
        window.dispatchEvent(new CustomEvent('appReloadRequired', {
          detail: {
            appVersion,
            forceReload,
            isAppReloadRequired
          }
        }));
      }

      return response;
    },
    (error) => Promise.reject(error)
  );
}
attachInterceptors(axios);
// Monkey-patch axios.create to attach interceptors to all new instances
const originalCreate = axios.create;

axios.create = function (...args) {
  const instance = originalCreate.apply(this, args);
  attachInterceptors(instance);
  return instance;
};


let _api = null;
let _hubUrl = null;

const api = () => _api;
export const hubUrl = () => _hubUrl;

export default api;

export const configureApi = (endpoint) => {
  _api = axios.create({
    baseURL: endpoint,
  });

  configureHubs(endpoint);
};

const configureHubs = (endpoint) => {
  _hubUrl = endpoint + '/signalr';
};
